import { render, staticRenderFns } from "./peoplemanage.vue?vue&type=template&id=6b0ae64f&scoped=true&"
import script from "./peoplemanage.vue?vue&type=script&lang=js&"
export * from "./peoplemanage.vue?vue&type=script&lang=js&"
import style0 from "./peoplemanage.vue?vue&type=style&index=0&id=6b0ae64f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0ae64f",
  null
  
)

export default component.exports